import { createAPI } from '../../common'

export default {
  // 统一检索-索引数量统计
  queryCountNum: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.gut0nfejbyGut0dpvou', 'post', config, vconfig),
  // 统一检索-检索
  querySearch: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.gut0nfejbyGut0mjtu', 'post', config, vconfig),
  // 统一检索-导出
  exportExcel: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.gut0nfejbyGut0mjtuFyqpsu', 'post', config, {
      ...vconfig,
      timeout: 60000
    }),
  // 搜索词联想接口
  queryExpand: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0bj0rvfszFyqboe', 'post', config, {
      neverLoading: true
    }),
  // 搜索词纠错接口
  queryCorrect: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0bj0rvfszDpssfdu', 'post', config),
  // 统一检索
  queryImageList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.gut0nfejbyGut0jnbhfMjtu', 'post', config, {
      isHideErrorMessage: true
    }),
  // 依文配图接口
  queryArticlePhoto: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.gut0nfejbyGut0bsujdmfQipup', 'post', config, {
      ...vconfig,
      timeout: 120000
    }),
  // 统一检索-视频打点图片
  downloadVideoImage: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.gut0nfejbyGut0epxompbeJnh',
      'get',
      { ...config, responseType: 'arraybuffer' },
      {
        isHideErrorMessage: true
      }
    ),
  // 图片本地化
  postPhotosLocalization: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0qipup0mpdbmj{bujpo', 'post', config),
  getPhotoDownload: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0qipup0epxompbe', 'get', config, vconfig),
  getImageTags: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0gpvoefsBJ0hfuFyuJnbhfUbht', 'get', config, {
      isHideErrorMessage: true
    }), // 获取图片自动化标签
  queryAuthorization: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.gut0nfejbyGut0qfsnjttjpo', 'get', config, {
      isHideErrorMessage: true
    }), // 查询以图搜图、跨模态检索、图搜视频是否授权
  postSearchWordList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tubu0fwfouTubu0tfbsdiXpseMjtu', 'post', config, {
      isHideErrorMessage: true
    }), // 智能媒资首页-热搜词
  // 统一检索-导出
  exportImgExcel: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.gut0nfejbyGut0jnbhfMjtuFyqpsu', 'post', config),
  // 索引重建任务列表
  getIndexRebuildIndexList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.gut0sfcvjme0ubtlMjtu', 'GET', config),
  //停止索引
  stopIndex: (config) => createAPI('customEncryptApiName-1/0nfejby.gut0sfcvjme0tupq', 'post', config),
  // 重建索引
  getRebuildIndex: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.gut0sfcvjme0dsfbuf', 'post', config, {}),
  // 索引重建记录
  getrecordList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.gut0sfcvjme0sfdpseMjtu', 'GET', config),
  // 统一检索-批量下载
  postBatchDownload: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.gut0nfejbyGut0bsujdmf0cbudi0epxompbe', 'POST', config),
  getFtsRoot: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.gut0f60gpmefst0sppu', 'get', config),
  getFtsActionFolder: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.gut0f60benjo0qfsnjttjpot0bdujpot0gpmefs', 'get', config),
  postFtsActionFolder: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.gut0f60benjo0qfsnjttjpot0bdujpot0gpmefs',
      'post',
      config
    ),
  postFtsbrowsePermission: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.gut0nfejbyGut0cspxtfQfsnjttjpo', 'post', config),
  //新华社清理--列表
  getTaskList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.gut0xjsfdmfbo0ubtlMjtu', 'get', config),
  //新华社清理--配置任务
  postInitTask: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.gut0xjsfdmfbo0jojuUbtl', 'post', config),
  //新华社清理--日志列表
  getrecordListXHS: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.gut0xjsfdmfbo0sfdpseMjtu', 'get', config),
  //新华社清理--暂停任务
  getPauseTask: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.gut0xjsfdmfbo0qbvtf', 'get', config),
  //新华社清理--重新启动
  getCancelPause: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.gut0xjsfdmfbo0dbodfmqbvtf', 'get', config),
  //新华社清理--任务信息
  getTaskInfo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.gut0xjsfdmfbo0ubtlJogp', 'get', config),
  //报纸回退--获取任务列表GET
  getPaperArticleRevokeList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.gut0ubtl0qbqfs0sfwplf0ubtlMjtu', 'GET', config),
  //报纸回退--新建或初始化任务
  postPaperArticleRevokeInit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.gut0ubtl0qbqfs0sfwplf0jojuUbtl', 'POST', config),
  //报纸回退--获取单个任务GET
  getPaperArticleRevokeInfo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.gut0ubtl0qbqfs0sfwplf0ubtlJogp', 'GET', config),
  //报纸回退--禁用任务GET
  disablePaperArticleRevoke: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.gut0ubtl0qbqfs0sfwplf0ejtbcmfUbtl', 'GET', config),
  //报纸回退--启用任务GET
  enablePaperArticleRevoke: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.gut0ubtl0qbqfs0sfwplf0fobcmfUbtl', 'GET', config),
  //报纸回退--任务日志
  getPaperArticleRevokeRecordList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.gut0ubtl0qbqfs0sfwplf0sfdpseMjtu', 'GET', config),
  /******************************制作任务 API****************************** */
  //制作任务--获取任务列表GET
  getPhotoMakeCleanList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.gut0ubtl0qipupnblf0dmfbo0ubtlMjtu', 'GET', config),
  //制作任务--新建或初始化任务
  postPhotoMakeCleanInit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.gut0ubtl0qipupnblf0dmfbo0jojuUbtl', 'POST', config),
  //制作任务--获取单个任务GET
  getPhotoMakeCleanInfo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.gut0ubtl0qipupnblf0dmfbo0ubtlJogp', 'GET', config),
  //制作任务--禁用任务GET
  disablePhotoMakeClean: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.gut0ubtl0qipupnblf0dmfbo0ejtbcmfUbtl', 'GET', config),
  //制作任务--启用任务GET
  enablePhotoMakeClean: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.gut0ubtl0qipupnblf0dmfbo0fobcmfUbtl', 'GET', config),
  //制作任务--任务日志
  getPhotoMakeCleanRecordList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.gut0ubtl0qipupnblf0dmfbo0sfdpseMjtu', 'GET', config),
  //开启发送数据 工单号：#691800
  postRebuildTagStatus: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.gut0sfcvjme0ubhTubuvt', 'POST', config),
  //查询稿件稿签媒资标签挂载分类
  getArticleTagCat: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0epnMbcfm0bsujdmfUbhDbu', 'GET', config),

  /* ****************************数据清理和数据归档-资产库生产库 API****************************** */

  // 数据清理--资产库+生产库任务设置
  postDataCleanProductionSource: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpc0ubtl0bee', 'POST', config),
  // 获取设置的任务详情
  getLastTaskDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpc0ubtl0mbtuUbtl', 'GET', config),
  // 数据清理--资产库+生产库任务列表
  getProductionSourceTaskList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpc0ubtl0tvcMjtu', 'GET', config),
  // 获取知识库任务列表
  getKnowledgeTaskList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpc0ubtl0xbjuBoeSvo0tvcMjtu', 'GET', config),
  // 数据清理--停止资产库+生产库任务
  stopProductionSourceTask: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpc0ubtl0tupq', 'POST', config),
  // 数据清理/归档--分组状态
  getGroupTaskStatus: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpc0ubtl0bttfuHspvqt', 'GET', config),
  // 获取数据归档主任务列表
  getDataArchiveList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpc0ubtl0mjtu', 'GET', config),
  // 数据归档和清理任务记录
  productSourceRecordList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpc0ubtl0sfdpseMjtu', 'GET', config),
  // 稿源库树根节点
  getOriginRoot: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0f60gpmefst0sppu', 'GET', config),
  // 稿源库树子节点
  getOriginFolders: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0f60benjo0epn0gpmefst', 'GET', config),
  // 审稿库树根节点
  getAuditRoot: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0f60gpmefst0sppu', 'GET', config),
  // 审稿库树子节点
  getAuditFolders: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0f60benjo0epn0gpmefst', 'GET', config),
  // 设置数据归档租户
  setArchiveTenant: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0ubtl0bsdijwfUfobou', 'POST', config),
  //文件回收站--已删除文件列表
  getGarbageList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sftpvsdf0hbscbhf0mjtu', 'GET', config),
  //文件回收站--彻底删除
  deleteGarbage: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sftpvsdf0hbscbhf0efmfuf', 'POST', config)
}
